import React from "react";

const ChevronRightIcon = ({ size = 24, className, ...inputProps }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2.5"
      stroke="currentColor"
      width={size}
      height={size}
      className={className}
      {...inputProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.25 4.5l7.5 7.5-7.5 7.5" // Path for a right-pointing chevron
      />
    </svg>
  );
};

export default ChevronRightIcon;